import { Box, Stack, Typography } from "@mui/material";
import HandshakeIcon from "@mui/icons-material/Handshake";
import PersonIcon from "@mui/icons-material/Person";
import PaymentIcon from "@mui/icons-material/Payment";
import InfoIcon from "@mui/icons-material/Info";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import BatteryChargingFullIcon from "@mui/icons-material/BatteryChargingFull";
import BatteryCharging20Icon from "@mui/icons-material/BatteryCharging20";

const InfoCard = ({
  data,
  title,
  bgcolor,
  color,
  sx,
  fieldsToShow,
  infoFor,
}) => {
  const renderValue = (value) => {
    if (Array.isArray(value)) {
      return value.join(", ");
    } else if (typeof value === "object") {
      return JSON.stringify(value);
    }

    if (typeof value === "string") {
      const lowerVal = value.toLowerCase();

      if (["active", "onboarded/active", "trial"].includes(lowerVal)) {
        return (
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                bgcolor: "#4CAF50",
              }}
            />
            <span>{value}</span>
          </Stack>
        );
      }

      if (
        ["leave", "on-leave", "blocked", "offboarded", "inactive"].includes(
          lowerVal
        )
      ) {
        return (
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                bgcolor: "#F44336", // red
              }}
            />
            <span>{value}</span>
          </Stack>
        );
      }
    }

    return value;
  };

  const getIcon = (infoFor) => {
    switch (infoFor) {
      case "Partner":
        return <HandshakeIcon />;
      case "Driver":
        return <PersonIcon />;
      case "Payment":
        return <PaymentIcon />;
      case "Subscription":
        return <CardMembershipIcon />;
      case "InBattery":
        return <BatteryCharging20Icon />;
      case "OutBattery":
        return <BatteryChargingFullIcon />;
      default:
        return <InfoIcon />;
    }
  };

  return (
    <Stack
      sx={{
        border: "1px solid #E0E0E0",
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: "#FFFFFF",
        boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
        mt: 2,
        ...sx,
      }}
    >
      {/* Header */}
      {title && (
        <Box
          sx={{
            bgcolor: bgcolor || "#1DA7A7",
            color: color || "#FFFFFF",
            fontWeight: 600,
            px: 2,
            py: 1,
            fontSize: "0.9rem",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 1,
          }}
        >
          {getIcon(infoFor)}
          {title}
        </Box>
      )}

      <Box sx={{ p: 2 }}>
        {data &&
          fieldsToShow &&
          Object.entries(fieldsToShow).map(([key, value]) => (
            <Box
              key={key}
              sx={{
                mb: 1,
                display: "flex",
                flexDirection: "row",
                gap: 1,
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="caption"
                sx={{ color: "#666", fontSize: "0.8rem" }}
              >
                {key}
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 500, display: "flex", alignItems: "center" }}
              >
                {renderValue(data[value])}
              </Typography>
            </Box>
          ))}
      </Box>
    </Stack>
  );
};

export default InfoCard;
